// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__HW-Xz","wrapper_empty":"style_wrapper_empty__JmJKD","wrapper_pagination":"style_wrapper_pagination__T0BMx"};